import React, {FC, SVGProps} from 'react';

const Frondosas: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 808.108 711.158"
    height="100%"
    fill="none"
    {...props}
  >
    <path
      fill="#959B76"
      d="m425.053 439.886-20.751-.011-21.07.045-.133-.44.204-20.682 20.908-.216 20.982-.013 21.084.296-.028 20.89-.092-.061-21.104.192zM362.006 586.613l-62.719-.029-.289-20.975.309.128 20.925-.12 20.874.085 20.896.111.2-.101c-.064 6.966-.13 13.933-.196 20.901zM509.107 418.566l-20.946.384.039-.428-.076-20.841-.059-20.884c.027-5.797.158-11.595.035-17.389-.06-2.804.976-3.824 3.76-3.735 5.79.185 11.588.152 17.382.207l-.057 20.864v20.959c-.027 6.954-.053 13.909-.078 20.863zM698.326 271.761c-.215 6.99-.442 13.981.129 20.966a.514.514 0 0 1-.489-.01l-20.734-.067-.121-20.979.044-20.955 20.862-.162.28.283.029 20.924z"
    />
    <path
      fill="#C7CBB8"
      d="m68.197 334.699-.133-21.057c.025-5.312.259-10.633.005-15.931-.181-3.775.779-5.422 4.923-5.134 5.287.368 10.617.109 15.929.121.181.01.362.026.542.047-.628 13.94-.314 27.884-.144 41.827l-.331.322-20.791-.195z"
    />
    <path
      fill="#959B76"
      d="m740.059 334.772-.02 41.813-20.678.131h-.445l.354-42.044 20.789.1z"
    />
    <path
      fill="#555A40"
      d="m299.386 502.677-.064-20.938 20.769-.065.083 21.039c-6.929-.011-13.859-.023-20.788-.036z"
    />
    <path
      fill="#747956"
      d="m320.09 481.675-20.768.065-.041-21.035 20.655.035.331 20.98-.177-.045z"
    />
    <path
      fill="#AEB29C"
      d="m614.158 439.859-.036 20.732c-6.955-.013-13.911-.025-20.866-.035l-.099-20.802 21.1-.286-.099.391z"
    />
    <path
      fill="#747956"
      d="m320.232 565.616-20.925.12.025-20.986 20.658-.114.242 20.98z"
    />
    <path
      fill="#959B76"
      d="m319.989 544.636-20.656.115.012-21.073 20.706.093.163 20.906a21.671 21.671 0 0 0-.225-.041z"
    />
    <path
      fill="#747956"
      d="m320.05 523.771-20.705-.094.041-21 20.788.037-.124 21.057z"
    />
    <path
      fill="#AEB29C"
      d="m298.922 439.724-20.689-.043-.129-20.696.131-.42 20.779.17.381 20.992-.473-.003zM509.107 418.566l.077-20.864 20.891.115.141 20.711-.048.461-21.061-.423zM383.232 439.919l-.106 20.679-20.832.397a1.611 1.611 0 0 1-.238-.458l.193-20.817 20.85-.242.133.441z"
    />
    <path
      fill="#555A40"
      d="m319.935 460.74-20.654-.035-.359-20.98.473.003 20.769.002.185 20.992-.414.018z"
    />
    <path
      fill="#AEB29C"
      d="m572.104 439.933-20.859-.261-.084-20.718.052-.491 20.896.336.184 20.665a7.65 7.65 0 0 1-.189.469zM194.228 397.683l-.13-20.699c.061-.165.115-.332.16-.502l20.87.364.088 20.708-.094.374-20.894-.245zM299.149 40.74l.019 20.697c.034.171.047.344.038.518l-21.002-.32-.044-20.74.034-.453c6.984.098 13.969.198 20.955.298z"
    />
    <path
      fill="#959B76"
      d="m89.25 271.73 20.854-.122c.044 5.829-.01 11.66.175 17.484.091 2.873-1.073 3.778-3.824 3.709-5.66-.142-11.326-.051-16.99-.057a8.934 8.934 0 0 0-.542-.047l.327-20.967zM719.079 250.615l-20.783.222-.279-.282.155-20.56.018-.468 20.971.264c-.026 6.941-.054 13.883-.082 20.824z"
    />
    <path
      fill="#747956"
      d="M89.464 292.746c5.664.005 11.33-.086 16.99.057 2.75.069 3.915-.836 3.824-3.709-.185-5.824-.13-11.656-.175-17.484l-.125-20.896.423.069c4.978-.018 9.985-.375 14.926.041 4.975.42 6.303-1.503 5.936-6.176-.389-4.948-.087-9.95-.087-14.929l20.99.01c.02 5.612.202 11.23-.003 16.833-.121 3.298 1.091 4.302 4.289 4.206 5.604-.169 11.219.039 16.828.087l-.185 20.78-20.94.091c-5.82.016-11.642.115-17.46.009-2.572-.047-3.552.886-3.504 3.482.108 5.818.004 11.64-.014 17.46l-.037 20.983c-5.489.041-10.985.274-16.464.053-3.396-.137-4.736.766-4.567 4.394.256 5.473-.026 10.972-.08 16.459l-20.712.007c-.167-13.943-.48-27.887.147-41.827z"
    />
    <path
      fill="#959B76"
      d="m89.275 187.809 20.689-.289.341.318-.246 41.927-20.765-.087-.019-41.869z"
    />
    <path
      fill="#AEB29C"
      d="m89.293 229.678 20.766.087.161-.075.182 21.092-.424-.07c-5.491.008-10.986-.124-16.47.079-3.137.116-4.543-.727-4.383-4.149.265-5.645.133-11.308.168-16.964z"
    />
    <path
      fill="#7F8942"
      d="m278.16 40.894.044 20.74-.051 21.056-42.069-.103.04-20.918.011-.009c5.494.015 11.002-.202 16.478.125 3.912.233 4.845-1.306 4.671-4.905-.256-5.315-.043-10.652-.029-15.98l20.905-.006z"
    />
    <path
      fill="#959B76"
      d="M257.255 40.899c-.014 5.328-.227 10.665.029 15.98.174 3.599-.759 5.139-4.671 4.905-5.476-.326-10.984-.109-16.478-.125.025-5.62.226-11.246.007-16.856-.13-3.322 1.07-4.303 4.267-4.152 5.607.268 11.23.185 16.846.248zM236.124 61.669l-.04 20.919.057.078-20.954.269-.025-.458.062-20.625 20.9-.183z"
    />
    <path
      fill="#AEB29C"
      d="m425.247 82.476 20.94.308.009 20.79-21.051.22.095-.245-.075-20.767.082-.306z"
    />
    <path
      fill="#959B76"
      d="m446.196 103.573-.009-20.789 20.965.037.101 20.708-21.154.356.097-.312z"
    />
    <path
      fill="#AEB29C"
      d="m467.253 103.527-.101-20.706 20.985-.281.069.298-.057 20.92-20.967.043.071-.274z"
    />
    <path
      fill="#555A40"
      d="m719.068 397.606-20.926.285-20.928-.346-.084-20.762 21.02-.155 20.765.089h.445l-.292 20.889z"
    />
    <path
      fill="#747956"
      d="m677.13 376.782.085 20.762-20.991.303-21.108-.146.036.054.014-21.014 41.964.041z"
    />
    <path
      fill="#AEB29C"
      d="M635.296 418.681c6.931.034 13.863.067 20.793.102l-.015 20.828c-6.942.119-13.882.239-20.823.36l-.19-.456.235-20.834z"
    />
    <path
      fill="#40461E"
      d="m467.114 418.592-20.838.273-21.084-.295c-.003-5.487-.2-10.984.059-16.46.171-3.603-1.227-4.6-4.619-4.46-5.479.226-10.973.068-16.461.073l.001.001.009-21.005c5.77.002 11.543-.092 17.309.048 2.779.068 3.804-.961 3.737-3.738-.14-5.767-.046-11.539-.048-17.309l41.871-.04.143 21.044-.052-.049c-5.663.024-11.33.192-16.987.016-3.092-.096-4.114 1.029-3.984 4.048.194 4.489.146 8.996.017 13.489-.074 2.575.883 3.563 3.484 3.514 5.828-.11 11.659-.01 17.489.005l.111-.029c-.051 6.956-.104 13.915-.157 20.874z"
    />
    <path
      fill="#555A40"
      d="m383.099 439.48-20.85.242-.387.032c.105-5.427.429-10.862.233-16.278-.13-3.594.838-5.03 4.664-4.834 5.418.276 10.865-.004 16.299-.047l.245.203-.204 20.682z"
    />
    <path
      fill="#6B762F"
      d="m404.211 418.582-20.908.216-.244-.202.199-20.792 20.915-.08-.001-.001.039 20.859z"
    />
    <path
      fill="#505721"
      d="m404.211 418.582-.038-20.859c5.488-.004 10.982.153 16.461-.073 3.391-.14 4.789.857 4.619 4.46-.259 5.475-.062 10.972-.059 16.46-6.995.003-13.989.007-20.983.012z"
    />
    <path
      fill="#555A40"
      d="m320.232 565.616-.242-20.98.223.041 20.856.033.286-.063-.248 21.055c-6.959-.03-13.917-.058-20.875-.086z"
    />
    <path
      fill="#747956"
      d="m467.195 376.722-.142-21.044.139-20.828 41.999-.019-.022 20.814.071.236c-5.794-.056-11.592-.023-17.382-.208-2.785-.089-3.82.931-3.76 3.735.123 5.793-.008 11.592-.034 17.388l-20.869-.074z"
    />
    <path
      fill="#555A40"
      d="m467.195 376.722 20.87.074.059 20.885-20.851.035-.111.029-.02-21.072.053.049z"
    />
    <path
      fill="#747956"
      d="m530.075 397.818-20.891-.116v-20.959l20.941-.084.211 20.899-.261.26zM467.273 397.716l20.851-.035.076 20.841-21.085.07.158-20.876z"
    />
    <path
      fill="#AEB29C"
      d="m530.124 376.659-20.941.084.057-20.864-.071-.235c5.62.032 11.246.226 16.859.03 3.169-.111 4.411.778 4.249 4.126-.273 5.61-.124 11.239-.153 16.859z"
    />
    <path
      fill="#40461E"
      d="m341.069 544.71-20.856-.033-.163-20.906.124-21.057-.083-21.039.175.044 20.692.045.388-.06-.277 63.006z"
    />
    <path
      fill="#959B76"
      d="m152.282 103.745 20.767-.141.199 21.153-.127 20.848-20.904.393-.063-.471.128-41.782zM109.964 187.52l.403-41.619 20.891.041.011 20.831c-.058 5.637-.26 11.277-.115 16.909.077 2.997-.845 4.109-3.943 4.022-5.63-.158-11.27.069-16.906.135l-.341-.319z"
    />
    <path
      fill="#7F8942"
      d="m131.269 166.773-.011-20.831 20.896-.415.063.47-.07 20.686-20.878.09z"
    />
    <path
      fill="#959B76"
      d="m278.103 418.985-20.88-.408-.066-20.674.011-.385 20.765.258.3 20.789-.13.42zM215.215 397.555l-.088-20.709 20.98-.051.154 20.777-21.046-.017z"
    />
    <path
      fill="#747956"
      d="m236.262 397.572-.154-20.778 21.064.026-.004 20.697-.011.385-20.895-.33z"
    />
    <path
      fill="#555A40"
      d="m697.966 292.717.329 20.882-.341.342-41.726-.272.056-21.021 20.949.002 20.733.067z"
    />
    <path
      fill="#747956"
      d="m698.173 229.994-.155 20.56-20.863.161-20.932-.043.003-20.997 20.993-.005 20.954.324z"
    />
    <path
      fill="#555A40"
      d="m656.223 250.673 20.931.043-.044 20.955-20.799.023-.269.074.025-20.939.156-.156z"
    />
    <path
      fill="#747956"
      d="m656.312 271.694 20.799-.023.121 20.979-20.949-.002.029-20.954z"
    />
    <path
      fill="#AEB29C"
      d="m152.11 334.772.065-21.065-.025-21.008.016-.014 21.002.016 20.935-.033.068 20.857c-5.792.071-11.588.285-17.376.15-2.845-.066-3.713.879-3.639 3.679.153 5.791-.018 11.591-.056 17.387l-20.765-.036-.225.067z"
    />
    <path
      fill="#959B76"
      d="m152.149 292.699.025 21.008-21.032-.047.037-20.983 20.97.022z"
    />
    <path
      fill="#40461E"
      d="m718.915 376.716-20.764-.088.039-41.941 20.878.092.201-.108-.354 42.045z"
    />
    <path
      fill="#959B76"
      d="m425.164 82.781.075 20.767-20.981.232-21.151.048-20.875-.141-.117-20.79 21.019-.291 42.03.175z"
    />
    <path
      fill="#7F8942"
      d="m362.115 82.896.117 20.79c-12.407.011-24.818-.155-37.218.131-4.159.096-5.058-1.453-4.888-5.174.241-5.281.025-10.583.004-15.876l.166-.161h20.974l20.845.29z"
    />
    <path
      fill="#959B76"
      d="m341.27 82.606-20.975.001-.149-20.758 20.927-.026.197 20.783zM488.147 103.758l.058-20.92 21.026-.248 20.846.214c.035 5.813.161 11.626.066 17.436-.042 2.579.888 3.531 3.478 3.483 5.81-.108 11.625.005 17.437.029l.256 20.822-.267.276-41.977-.385c.02-5.135-.189-10.286.133-15.404.252-4.007-.849-5.677-5.162-5.384-5.278.358-10.6.069-15.902.059a.195.195 0 0 0 .008.022zM593.192 145.416l20.951.337.219 20.768-.322.336-20.76-.259-.112-20.717.024-.465z"
    />
    <path
      fill="#959B76"
      d="m635.105 166.773.194 20.819-.226.229-20.773-.214-.262-20.75.322-.336 20.745.252z"
    />
    <path
      fill="#7F8942"
      d="m173.248 124.756-.199-21.153.272-20.792 20.826-.234 21.014-.101.025.457-.039 20.725.038.067c-5.768.003-11.538.105-17.302-.036-2.745-.067-3.823.858-3.755 3.681.14 5.764.015 11.534-.002 17.301l-20.878.085zM320.145 61.849l.149 20.758-.164.159-20.954-.044-.002-.002.032-20.765a2.143 2.143 0 0 0-.038-.518l20.977.412z"
    />
    <path
      fill="#959B76"
      d="m152.332 334.705 20.765.036.312-.127-.09 20.963-.319.305-20.631-.229-.037-20.948z"
    />
    <path
      fill="#31361B"
      d="m340.958 481.764-20.692-.045c-.109-6.993-.219-13.987-.331-20.98l.412-.019 20.661-.176.239.24-.289 20.98z"
    />
    <path
      fill="#31361B"
      d="m362.249 439.721-.193 20.817-20.808.247-.238-.238.152-20.803 20.698.01.389-.033z"
    />
    <path
      fill="#5E6337"
      d="m635.296 418.681-.235 20.834-20.902.344.099-.391-.081-20.77.069-21.048 20.907.106-.036-.054.179 20.979z"
    />
    <path
      fill="#555A40"
      d="m614.177 418.698.081 20.77-21.1.286.103-.184-.07-20.805-.05-.155 21.036.088z"
    />
    <path
      fill="#747956"
      d="m593.191 418.765.07 20.805-20.968-.105-.184-20.666 21.082-.034z"
    />
    <path
      fill="#959B76"
      d="m194.098 376.984-20.891-.356-.206-20.747.318-.304 20.747.233.191 20.672a5.325 5.325 0 0 1-.159.502z"
    />
    <path
      fill="#555A40"
      d="m719.068 334.779-20.878-.092-.236-20.746.341-.342 20.84.28-.067 20.9z"
    />
    <path
      fill="#31361B"
      d="m320.164 439.729-20.769-.002-.381-20.992.35.057 20.799-.056.034 20.994-.033-.001z"
    />
    <path
      fill="#5E6337"
      d="m278.234 418.565-.299-20.79.377-.095 20.839.065.215 21.047-.352-.058-20.78-.169z"
    />
    <path
      fill="#747956"
      d="m551.16 418.954-20.944-.426-.141-20.711.26-.258 20.821.181.056 20.722-.052.492z"
    />
    <path
      fill="#272914"
      d="m341.162 439.744-.152 20.803c-6.889.057-13.776.116-20.662.175-.06-6.997-.122-13.995-.184-20.992l.032.001 20.966.013z"
    />
    <path
      fill="#40461E"
      d="m551.212 418.463-.056-20.722c.017-12.453.17-24.908-.03-37.357-.061-3.764 1.114-5.006 4.821-4.747 4.131.288 8.301-.048 12.447.104 2.745.1 3.921-.829 3.813-3.694-.162-4.311.169-8.645-.103-12.945-.229-3.619 1.249-4.568 4.617-4.437 5.47.213 10.956.04 16.435.031l.048 42.078.051 20.868-.113 20.969.05.155-21.083.034-20.897-.337z"
    />
    <path
      fill="#555A40"
      d="m194.257 376.483-.191-20.672.26-.271 41.88.118c6.982.072 13.963.144 20.945.214l.051 20.812-.03.138-21.064-.027-20.981.052-20.87-.364z"
    />
    <path
      fill="#959B76"
      d="m656.03 187.866.292 20.701-.283.29-20.793-.219-.173-20.816.226-.23 20.731.274zM677.219 229.671l-20.993.006-.125.057-.062-20.876.283-.29 20.715.292.182 20.811z"
    />
    <path
      fill="#6B762F"
      d="m299.206 61.955-.032 20.765-21.021-.03.051-21.056 21.002.321z"
    />
    <path
      fill="#959B76"
      d="m572.113 124.901.066 20.621.002.448-20.893-.334-.242-20.786.267-.276 20.8.327z"
    />
    <path
      fill="#6B762F"
      d="m593.168 145.88.112 20.718-.221.212c-5.454-.034-10.914-.241-16.36-.04-3.38.125-4.75-.866-4.58-4.439.259-5.443.065-10.907.064-16.362l-.002-.448 20.987.359zM131.269 166.773l20.878-.09.098.098.026 62.842-.104.106-20.99-.011-20.956-.028-.161.075.245-41.927c5.636-.066 11.277-.292 16.906-.134 3.098.087 4.02-1.025 3.943-4.022-.145-5.632.057-11.272.115-16.909z"
    />
    <path
      fill="#5E6337"
      d="m152.149 292.699-20.971-.022c.018-5.821.122-11.642.014-17.46-.048-2.596.932-3.529 3.504-3.482 5.818.106 11.64.007 17.46-.009l.008 20.96-.015.013z"
    />
    <path
      fill="#959B76"
      d="m152.165 292.685-.008-20.96 20.94-.091.216.213-.146 20.854-21.002-.016z"
    />
    <path
      fill="#7F8942"
      d="m110.22 229.69 20.956.028c0 4.979-.303 9.981.087 14.929.368 4.674-.96 6.596-5.936 6.176-4.942-.417-9.948-.06-14.926-.041-.059-7.03-.12-14.061-.181-21.092z"
    />
    <path
      fill="#5E6337"
      d="M173.283 250.856c-5.61-.05-11.225-.258-16.829-.088-3.198.097-4.41-.908-4.289-4.206.205-5.604.022-11.221.003-16.833l.103-.105c5.821.028 11.644.138 17.463.044 2.59-.042 3.547.946 3.495 3.515-.119 5.82-.051 11.644-.059 17.466l.113.207z"
    />
    <path
      fill="#959B76"
      d="m173.097 271.635.185-20.78-.112-.205 20.973.322-.037 20.795-20.793.081-.216-.213z"
    />
    <path
      fill="#5E6823"
      d="m278.153 82.69 21.021.03.002.002c0 12.598.089 25.197-.062 37.794-.039 3.261 1.029 4.371 4.279 4.263 5.628-.188 11.269-.002 16.904.027-.034 5.656.062 11.318-.155 16.967-.12 3.102 1.063 4.071 4.06 3.978 5.652-.174 11.313-.049 16.971-.048.002 5.81.068 11.621-.024 17.43-.039 2.447.685 3.69 3.379 3.617 4.811-.131 9.628-.097 14.441-.013 2.331.04 3.281-.906 3.239-3.238-.084-4.647-.173-9.302.034-13.941.142-3.186-1.258-3.969-4.144-3.891-5.64.152-11.287.045-16.931.045l-.094-20.914 42.106-.092.014.013c0 5.462.227 10.937-.076 16.382-.215 3.858 1.276 4.911 4.876 4.667 3.954-.268 7.949-.223 11.911-.011 3.186.171 4.458-.865 4.324-4.195-.227-5.619-.078-11.253-.087-16.88l.118-20.899 20.981-.232-.095.245c.007 5.663.151 11.331-.032 16.988-.1 3.098 1.072 4.083 4.072 3.991 5.658-.173 11.325-.052 16.988-.054l.004.003.002 20.995c-5.766.003-11.535.104-17.298-.034-2.779-.066-3.798.958-3.732 3.735.137 5.763.035 11.532.032 17.298l-21.031.038c-5.833-.011-11.668.059-17.498-.068-2.602-.057-3.54.947-3.493 3.519.107 5.831.016 11.665.005 17.498-5.655.005-11.314.131-16.965-.035-2.982-.087-4.18.867-4.079 3.975.184 5.649.038 11.309.03 16.964l-20.973.105c-.002-5.804-.069-11.609.024-17.412.039-2.448-.689-3.682-3.379-3.608-4.805.132-9.618.098-14.426.013-2.329-.041-3.277.902-3.235 3.233.084 4.642.174 9.293-.034 13.927-.142 3.179 1.244 3.969 4.133 3.891 5.634-.152 11.275-.043 16.913-.042l-.023 20.982-20.979.027-20.902-.102c-.031-5.658-.207-11.32-.035-16.971.095-3.123-1.109-4.048-4.084-3.961-5.653.166-11.315.036-16.974.029l.019-21.02c5.827.003 11.655-.073 17.48.045 2.569.052 3.571-.885 3.513-3.487-.13-5.824-.059-11.653-.07-17.479.018-5.774-.056-11.55.094-17.32.071-2.743-.879-3.846-3.699-3.776-5.77.143-11.547.04-17.321.039l-21.033.019c-5.771-.005-11.545.091-17.313-.058-2.804-.073-3.769.989-3.711 3.749.122 5.768-.005 11.541-.029 17.312l-20.881-.017-.042-62.998-.038-.067 21.035.054c.003 5.805.069 11.611-.022 17.414-.038 2.439.672 3.693 3.37 3.619 4.806-.131 9.619-.097 14.428-.013 2.332.041 3.275-.909 3.233-3.237-.084-4.642-.174-9.294.034-13.929.142-3.18-1.245-3.969-4.134-3.891-5.635.153-11.277.044-16.916.043l-.036-21.054-.056-.077c14.026.03 28.049.065 42.072.099z"
    />
    <path
      fill="#6B762F"
      d="m236.183 103.713-21.036-.054.039-20.725c6.985-.088 13.97-.178 20.954-.268l.036 21.054.007-.007zM446.173 124.719c-5.663.001-11.33-.119-16.988.054-3 .092-4.172-.893-4.072-3.991.183-5.657.039-11.325.032-16.988l21.051-.22-.096.31.073 20.835z"
    />
    <path
      fill="#7F8942"
      d="m446.173 124.719-.073-20.835c7.051-.117 14.102-.235 21.153-.355l-.072.272-.02 20.896-20.983.026-.005-.004z"
    />
    <path
      fill="#6B762F"
      d="m467.16 124.696.021-20.895 20.967-.043-.009-.022.1 20.926-21.025.088-.054-.054z"
    />
    <path
      fill="#31361B"
      d="m697.954 313.941.236 20.746-.039 41.941-21.021.154-41.964-.04.08-.223-.085-20.783c5.772 0 11.547-.096 17.315.043 2.747.067 3.838-.874 3.762-3.694-.154-5.768-.06-11.543-.068-17.315l-.037-21.007.095-.094 41.726.272z"
    />
    <path
      fill="#959B76"
      d="m635.152 397.756-20.907-.106.001.011.001-20.879-.086-.094 21.085-.17-.08.223-.014 21.015z"
    />
    <path
      fill="#31361B"
      d="m467.192 334.851-.139 20.827-41.872.04-20.982.02-41.992-.07.149-21.013 20.837.046 20.969-.001 21.048-.021h20.937l21.06-.081-.015.253z"
    />
    <path
      fill="#505721"
      d="m404.173 397.723-20.916.079c-.026-5.616.089-11.236-.13-16.843-.125-3.195.906-4.427 4.207-4.3 5.607.215 11.228.056 16.844.055l.005.005-.01 21.004z"
    />
    <path
      fill="#5E6337"
      d="m467.143 376.672.02 21.072c-5.83-.014-11.662-.114-17.489-.004-2.602.049-3.558-.939-3.484-3.514.129-4.494.177-9-.017-13.489-.13-3.019.892-4.145 3.984-4.048 5.655.176 11.323.008 16.986-.017z"
    />
    <path
      fill="#505721"
      d="m404.199 355.738 20.982-.02c.002 5.77-.092 11.543.048 17.309.067 2.778-.958 3.806-3.737 3.738-5.767-.14-11.539-.046-17.309-.048l-.005-.005.021-20.974z"
    />
    <path
      fill="#40461E"
      d="m404.199 355.738-.022 20.975c-5.615.002-11.237.16-16.844-.055-3.301-.126-4.332 1.105-4.207 4.3.219 5.607.104 11.227.13 16.843-.065 6.932-.132 13.863-.198 20.793-5.435.042-10.882.322-16.3.046-3.826-.195-4.794 1.24-4.664 4.834.196 5.416-.128 10.851-.233 16.278l-20.7-.01-20.966-.013-.034-20.995c5.771-.008 11.545-.113 17.313.018 2.759.062 3.826-.918 3.757-3.718-.143-5.768-.045-11.542-.046-17.313 5.463.001 10.938-.224 16.384.079 3.861.214 4.737-1.295 4.679-4.88-.199-12.412-.095-24.829-.106-37.245l.064-.009 41.993.072z"
    />
    <path
      fill="#555A40"
      d="M593.156 334.695c-5.479.01-10.965.182-16.435-.031-3.368-.131-4.846.818-4.617 4.437.272 4.3-.059 8.634.103 12.945.108 2.866-1.069 3.795-3.813 3.694-4.145-.152-8.316.184-12.447-.104-3.708-.258-4.882.984-4.821 4.747.201 12.449.048 24.904.03 37.357l-20.822-.181c-.069-6.968-.139-13.934-.21-20.9.028-5.621-.121-11.25.152-16.858.163-3.348-1.079-4.236-4.249-4.126-5.612.196-11.238.001-16.859-.03l.022-20.814-.091-.325 21.09.125c5.832.031 11.667-.022 17.496.131 2.608.068 3.521-.914 3.476-3.498-.102-5.83.021-11.664.052-17.496 12.568-.02 25.137.042 37.704-.117 3.16-.04 4.461.835 4.324 4.179-.23 5.613-.077 11.242-.085 16.865z"
    />
    <path
      fill="#1B1A0C"
      d="m509.191 334.831-41.999.019.016-.253.004-21.012 20.941.07 21.011.077-.064 20.772.091.327z"
    />
    <path
      fill="#5E6823"
      d="m173.248 124.756 20.879-.084.016 41.997-20.954.099-.019-.113-.05-21.05.128-20.849z"
    />
    <path
      fill="#6B762F"
      d="m173.121 145.604.05 21.051-20.925.126-.098-.098.07-20.686 20.903-.393z"
    />
    <path
      fill="#7F8942"
      d="m257.169 397.517.004-20.697.03-.137 20.906.107.204 20.89-.377.095-20.767-.258z"
    />
    <path
      fill="#31361B"
      d="m656.312 271.694-.029 20.954-.055 21.02-.094.093-20.956-.047.005.002c-.002-5.769-.1-11.541.037-17.307.066-2.776-.953-3.806-3.734-3.739-5.766.139-11.538.042-17.307.043l.005.005c.001-5.769-.094-11.541.046-17.307.068-2.781-.963-3.801-3.739-3.734-5.766.139-11.538.042-17.307.042l-.005-.007.017-21.012 21.021-.021 20.945.101c.008 5.643.139 11.29-.027 16.929-.088 2.991.895 4.152 3.98 4.057 5.637-.173 11.285-.017 16.928.002l.269-.074z"
    />
    <path
      fill="#555A40"
      d="m635.161 250.78-20.946-.1-.09-20.915 41.975-.031.125-.057-.003 20.996-.154.154-20.907-.047z"
    />
    <path
      fill="#40461E"
      d="m635.161 250.78 20.908.047-.026 20.94c-5.644-.018-11.292-.174-16.929-.001-3.085.095-4.068-1.066-3.98-4.057.166-5.638.035-11.285.027-16.929z"
    />
    <path
      fill="#505721"
      d="M173.098 334.742c.038-5.796.209-11.596.056-17.387-.074-2.8.794-3.746 3.639-3.679 5.788.135 11.584-.08 17.376-.15a.848.848 0 0 0-.023.496l.017 20.671-20.754-.078-.311.127z"
    />
    <path
      fill="#747956"
      d="m194.169 313.525-.068-20.857.096.055 20.73-.114.273 21.127-21.055.285a.857.857 0 0 1 .024-.496z"
    />
    <path
      fill="#6B762F"
      d="M320.298 124.805c-5.635-.029-11.276-.215-16.904-.027-3.251.108-4.318-1.001-4.279-4.263.15-12.596.061-25.196.062-37.794l20.954.044c.02 5.294.237 10.596-.005 15.877-.17 3.721.729 5.27 4.888 5.174 12.4-.286 24.811-.12 37.218-.131l20.876.14.071 20.877-42.105.091c-6.925.005-13.85.009-20.776.012z"
    />
    <path
      fill="#7F8942"
      d="m383.179 124.703-.071-20.877 21.15-.047-.117 20.9-20.948.036-.014-.012zM551.047 124.849l.241 20.787-42.099.073-.021-20.963-.098-.282 41.977.385z"
    />
    <path
      fill="#AEB29C"
      d="m488.239 124.661-.1-20.926c5.303.01 10.624.299 15.902-.059 4.313-.293 5.414 1.377 5.162 5.384-.322 5.118-.112 10.269-.133 15.404l.097.281-20.942-.09.014.006z"
    />
    <path
      fill="#5E6337"
      d="M614.039 166.857c.087 6.917.175 13.833.261 20.751l-.132 21.12.025-.025-20.99.015-.082-21.014-.063-20.894.221-.212 20.76.259z"
    />
    <path
      fill="#747956"
      d="m614.168 208.728.132-21.12c6.925.07 13.85.141 20.774.213l.172 20.817-21.078.09z"
    />
    <path
      fill="#505721"
      d="m194.143 166.669-.016-41.996c.016-5.768.141-11.538.001-17.302-.069-2.823 1.009-3.748 3.755-3.681 5.764.141 11.534.038 17.302.036l.042 62.998-.046.006c-7.012-.022-14.025-.042-21.038-.061z"
    />
    <path
      fill="#5E6337"
      d="m173.41 334.615 20.754.078.164 20.846-.261.272-20.747-.233.09-20.963z"
    />
    <path
      fill="#505721"
      d="m593.141 418.609.112-20.968 20.993.019-.001-.011-.068 21.048-21.036-.088zM341.186 397.722c.001 5.771-.096 11.545.046 17.313.069 2.8-.997 3.781-3.757 3.718-5.768-.131-11.542-.026-17.313-.018l-20.799.056-.213-21.047.042-.042 41.981.006.013.014z"
    />
    <path
      fill="#505721"
      d="m278.312 397.681-.204-20.89.13-.134 20.944.057.01 20.99-.042.042-20.838-.065z"
    />
    <path
      fill="#31361B"
      d="M593.156 334.695c.009-5.623-.145-11.252.087-16.866.138-3.344-1.163-4.219-4.324-4.179-12.566.159-25.136.097-37.704.116-.009-12.611-.106-25.222.034-37.831.036-3.244-.992-4.47-4.269-4.278-3.803.223-7.647-.179-11.441.114-3.965.306-5.742-.773-5.438-5.139.368-5.284.093-10.613.097-15.923 5.658 0 11.32-.126 16.973.049 3.012.093 4.147-.915 4.057-3.997-.165-5.652.003-11.313.032-16.971l20.937-.035c-.007 12.499.097 24.999-.091 37.495-.053 3.529 1.105 4.672 4.577 4.522 5.489-.238 10.996-.062 16.496-.061l.005.007c0 5.769.098 11.54-.042 17.305-.067 2.78.96 3.8 3.737 3.733 5.765-.139 11.536-.04 17.305-.039l-.005-.005c.002 5.769.101 11.54-.037 17.306-.066 2.779.957 3.801 3.736 3.735 5.766-.138 11.537-.038 17.306-.037l-.005-.002.002 21.002-.019 21.018c-5.765-.011-11.533.071-17.296-.074-2.771-.07-3.808.951-3.742 3.731.137 5.762.039 11.53.037 17.296l.086.094-21.043-.01-.048-42.076z"
    />
    <path
      fill="#5E6337"
      d="m593.204 376.772 21.043.01-.001 20.879-20.992-.019-.05-20.87z"
    />
    <path
      fill="#31361B"
      d="m257.151 355.873-20.945-.215-.106-21.046.014-20.814.063-21.079c12.749-.697 25.431 1.288 38.164.946 3.186-.086 3.96 1.267 3.878 4.142-.151 5.3-.038 10.608-.035 15.912l-.037 20.995c-5.826.001-11.653.078-17.476-.032-2.565-.048-3.573.901-3.523 3.496.113 5.823.031 11.651.028 17.476l-.025.219z"
    />
    <path
      fill="#40461E"
      d="m236.1 334.611.107 21.047-41.88-.118-.163-20.847-.018-20.672 21.054-.284-.031-.032c.004 5.662.133 11.327-.039 16.984-.091 3.004.89 4.176 3.989 4.059 5.654-.212 11.32-.109 16.981-.137z"
    />
    <path
      fill="#505721"
      d="m278.108 376.79-20.906-.107-.051-20.812.024-.217 20.977.119.086 20.884-.13.133z"
    />
    <path
      fill="#5E6337"
      d="m614.168 208.728 21.078-.089 20.793.218.062 20.877-41.975.031.057-.055.01-21.006-.025.024z"
    />
    <path
      fill="#505721"
      d="m593.058 166.811.063 20.895-41.969.002-20.929-.059c-.005-5.459-.159-10.924.042-16.376.12-3.26-.638-4.735-4.324-4.668-12.569.228-25.144.131-37.717.157l-21.03-.033-41.968.034-.047-.047c.004-5.766.105-11.535-.032-17.298-.066-2.777.953-3.801 3.732-3.735 5.763.138 11.532.037 17.298.034l20.978-.022 21.03.012 21.001.001 42.099-.073 20.894.334c.001 5.455.195 10.92-.064 16.362-.17 3.573 1.2 4.564 4.58 4.439 5.448-.2 10.909.006 16.363.041zM152.245 166.781l20.925-.126.019.112c-.002 5.495.176 11-.072 16.484-.16 3.517 1.075 4.587 4.554 4.539 12.488-.174 24.981-.067 37.472-.067l.092-.018-.111 20.952c-5.659.016-11.323.168-16.977-.006-3.073-.095-4.1 1.022-4.004 4.047.178 5.654.051 11.318.051 16.978l-.045 20.856-.006.44-20.973-.322c.008-5.823-.06-11.646.059-17.466.053-2.57-.905-3.557-3.495-3.515-5.82.094-11.643-.016-17.463-.044l-.026-62.844z"
    />
    <path
      fill="#747956"
      d="m194.106 271.766.037-20.795s.005-.44.006-.439l21.01.199-.216 21.08-20.814-.023-.023-.022z"
    />
    <path
      fill="#40461E"
      d="m341.178 208.711 20.973-.104.059.194c-.007 5.661.123 11.326-.076 16.98-.109 3.111 1.082 4.066 4.072 3.975 5.655-.172 11.32-.049 16.98-.048l.014 21.02-.041-.028-21.009.016-20.959-.013-.039-21.009.023-20.982.003-.001z"
    />
    <path
      fill="#6B762F"
      d="m278.198 187.696-.019 21.021.03.044-21.025-.036-20.972.011-.046-20.985.015-.008 21-.036 21.03-.014-.013.003z"
    />
    <path
      fill="#40461E"
      d="m257.181 187.705-21 .036-.073-21.002c.025-5.771.151-11.544.029-17.312-.058-2.761.906-3.822 3.711-3.749 5.768.15 11.541.053 17.313.058l.074 21.033-.054 20.936zM383.163 187.702c.01-5.833.101-11.667-.005-17.498-.047-2.572.891-3.576 3.493-3.519 5.83.128 11.665.058 17.498.068l.041 41.952-.044.044-20.991.03.027-.083-.019-20.994z"
    />
    <path
      fill="#505721"
      d="m404.19 208.706-.041-41.952 21.031-.037.046.046c-.013 12.565-.107 25.131.021 37.695.032 3.165-.865 4.46-4.195 4.327-5.613-.223-11.24-.073-16.862-.079zM257.236 166.77l-.075-21.033 21.033-.018.053 21.038-.044-.005-20.967.018z"
    />
    <path
      fill="#6B762F"
      d="m278.247 166.756-.053-21.038c5.774.001 11.551.104 17.321-.039 2.82-.07 3.77 1.033 3.699 3.776-.15 5.77-.076 11.546-.094 17.319l-20.873-.018z"
    />
    <path
      fill="#505721"
      d="M341.166 145.709c5.644 0 11.291.107 16.931-.045 2.886-.078 4.286.705 4.144 3.891-.206 4.639-.117 9.295-.034 13.941.042 2.333-.908 3.278-3.239 3.238-4.813-.083-9.63-.118-14.441.013-2.694.074-3.418-1.17-3.379-3.617.092-5.809.026-11.62.024-17.43.002.003-.006.009-.006.009z"
    />
    <path
      fill="#5E6337"
      d="m236.109 166.739.073 21.002-.015.008-20.932-.044-.091.018.038-20.995.046-.006 20.881.017z"
    />
    <path
      fill="#7F8942"
      d="m278.247 166.756 20.874.019c.01 5.827-.06 11.656.07 17.48.058 2.602-.944 3.539-3.513 3.487-5.825-.118-11.653-.042-17.48-.045l.013-.004-.008-20.942.044.005z"
    />
    <path
      fill="#6B762F"
      d="M341.175 208.713c-5.638-.001-11.279-.111-16.913.042-2.889.078-4.275-.712-4.133-3.891.207-4.634.118-9.285.034-13.927-.042-2.331.905-3.274 3.235-3.233 4.808.084 9.62.119 14.426-.013 2.689-.074 3.418 1.16 3.379 3.608-.093 5.803-.026 11.608-.024 17.412a.015.015 0 0 0-.004.002z"
    />
    <path
      fill="#505721"
      d="m383.163 187.702.018 20.995-20.972.105-.059-.195c.008-5.656.153-11.316-.031-16.965-.101-3.108 1.097-4.062 4.079-3.975 5.651.166 11.31.04 16.965.035z"
    />
    <path
      fill="#6B762F"
      d="M236.177 103.719c5.639.001 11.281.109 16.916-.043 2.889-.078 4.276.711 4.134 3.891-.207 4.635-.118 9.286-.034 13.929.042 2.328-.901 3.278-3.233 3.237-4.808-.084-9.621-.118-14.428.013-2.698.074-3.408-1.18-3.37-3.619.091-5.803.024-11.609.022-17.414l-.007.006z"
    />
    <path
      fill="#40461E"
      d="m320.298 124.805 20.776-.011c.03 6.972.061 13.944.093 20.915l.007-.007c-5.658-.001-11.319-.126-16.971.048-2.997.092-4.18-.877-4.06-3.978.217-5.649.121-11.31.155-16.967z"
    />
    <path
      fill="#6B762F"
      d="m383.193 124.716 20.948-.036c.009 5.627-.14 11.261.087 16.88.134 3.33-1.138 4.365-4.324 4.195-3.961-.212-7.956-.257-11.911.011-3.601.244-5.091-.809-4.876-4.667.303-5.446.076-10.921.076-16.383zM467.157 145.695l-20.978.022-.002-20.995 20.983-.026.052.053-.055 20.946z"
    />
    <path
      fill="#40461E"
      d="M278.179 208.716c5.658.007 11.321.137 16.974-.029 2.975-.087 4.179.838 4.084 3.961-.172 5.652.004 11.314.035 16.971l-.198.203-20.857-.07-.007-20.992-.031-.044z"
    />
    <path
      fill="#40461E"
      d="m299.271 229.62 20.902.102-.019 20.992-20.959.005-.123-20.896.199-.203z"
    />
    <path
      fill="#505721"
      d="m320.154 250.714.02-20.992 20.979-.027.039 21.008-.037.037-20.937-.03-.064.004z"
    />
    <path
      fill="#5E6823"
      d="m467.157 145.695.056-20.946 21.026-.087-.014-.006-.038 21.052-21.03-.013z"
    />
    <path
      fill="#555A40"
      d="m635.161 355.735.019-21.018 20.991.053c.008 5.772-.086 11.547.068 17.315.075 2.82-1.015 3.76-3.762 3.694-5.769-.141-11.544-.044-17.316-.044z"
    />
    <path
      fill="#272914"
      d="m656.171 334.769-20.991-.053-.002-21.002 20.956.047.037 21.008z"
    />
    <path
      fill="#40461E"
      d="M614.161 376.688c.001-5.766.099-11.534-.037-17.296-.066-2.78.971-3.801 3.742-3.731 5.762.146 11.53.063 17.296.074l.085 20.783-21.086.17z"
    />
    <path
      fill="#1B1A0C"
      d="m404.163 334.699-20.97.001-.092-21.075-.045-20.938.041-20.893.061-21.094.041.028c5.305-.002 10.621.196 15.913-.073 3.777-.192 5.491.792 5.135 4.932-.354 4.114.04 8.288-.116 12.427-.106 2.813.987 3.833 3.769 3.74 4.471-.151 8.959-.194 13.426.012 3.168.146 3.98-1.222 3.901-4.122-.155-5.633-.045-11.273-.045-16.91l20.968-.066 21.034.037-.038 20.984c-5.646.01-11.295.138-16.937-.02-2.956-.083-4.232.826-4.085 3.951.203 4.308-.127 8.642.105 12.947.181 3.357-1.172 4.249-4.346 4.205-10.626-.15-21.26.14-31.881-.145-4.412-.118-6.07.914-5.932 5.706.352 12.114.102 24.243.093 36.366z"
    />
    <path
      fill="#272914"
      d="M404.163 334.699c.009-12.122.259-24.252-.091-36.364-.138-4.792 1.52-5.824 5.932-5.706 10.62.285 21.255-.005 31.881.145 3.174.045 4.527-.848 4.346-4.205-.232-4.305.098-8.639-.105-12.947-.147-3.125 1.128-4.034 4.085-3.951 5.641.158 11.291.03 16.937.02l.084 21.067-.02 20.828-.004 21.012-21.06.08c.009-5.665-.112-11.335.079-16.995.104-3.072-1.018-4.146-4.05-4.013-4.324.189-8.669.189-12.994 0-3.031-.133-4.153.94-4.05 4.013.191 5.66.069 11.33.077 16.996l-21.047.02z"
    />
    <path
      fill="#555A40"
      d="m362.357 334.654-.15 21.014a.637.637 0 0 0-.063.009l-20.999-.052.026-20.918 20.906.022.28-.075z"
    />
    <path
      fill="#272914"
      d="m383.101 313.625.092 21.076-20.837-.046-.28.074.115-21.011 20.91-.093z"
    />
    <path
      fill="#1B1A0C"
      d="M425.211 334.678c-.008-5.666.114-11.336-.077-16.996-.104-3.073 1.018-4.145 4.05-4.013 4.324.189 8.669.189 12.994 0 3.032-.133 4.153.941 4.05 4.013-.191 5.66-.07 11.33-.079 16.995l-20.938.001z"
    />
    <path
      fill="#505721"
      d="m341.144 355.623 21 .053c.011 12.415-.093 24.832.106 37.244.057 3.585-.818 5.094-4.679 4.88-5.446-.302-10.921-.078-16.384-.079l-.012-.012c0-5.774-.102-11.55.042-17.32.07-2.817-1.024-3.763-3.771-3.704-5.77.125-11.546.012-17.319-.002l.092-20.906 20.925-.154z"
    />
    <path
      fill="#272914"
      d="M530.197 250.709c-.003 5.31.271 10.639-.097 15.923-.304 4.366 1.473 5.445 5.438 5.139 3.794-.293 7.638.109 11.441-.114 3.277-.192 4.305 1.034 4.269 4.278-.139 12.609-.043 25.22-.034 37.831-.031 5.833-.154 11.667-.052 17.497.045 2.584-.867 3.566-3.476 3.498-5.829-.153-11.664-.1-17.496-.13l-.017-20.903c.006-5.77-.084-11.542.058-17.309.068-2.762-.925-3.824-3.721-3.753-5.766.147-11.539.058-17.309.066l-20.925-.02-.095-.089.038-20.94c5.832.008 11.666-.062 17.496.06 2.599.055 3.547-.956 3.498-3.525-.112-5.83-.035-11.664-.035-17.496l21.006-.024.013.011z"
    />
    <path
      fill="#31361B"
      d="m530.174 313.728.017 20.903-21.09-.125.064-20.774.032-.032 20.977.028z"
    />
    <path
      fill="#555A40"
      d="m467.211 313.586.019-20.828 20.952-.136.094.09-.124 20.943-20.941-.069z"
    />
    <path
      fill="#31361B"
      d="m488.153 313.655.124-20.943 20.926.02-.006 20.968-.032.032-21.012-.077z"
    />
    <path
      fill="#40461E"
      d="m215.181 166.728-.038 20.995c-12.491 0-24.984-.107-37.472.067-3.479.048-4.713-1.021-4.554-4.539.249-5.485.07-10.989.072-16.484l20.954-.098 21.038.059z"
    />
    <path
      fill="#272914"
      d="M593.177 271.712c-5.5-.001-11.007-.177-16.496.061-3.472.15-4.63-.993-4.577-4.522.188-12.496.084-24.997.091-37.496l-.015-.115 21.044.009-.07.117.039 20.933c-.004 7.005-.01 14.009-.016 21.013zM614.182 292.718c-5.769-.001-11.54-.099-17.305.039-2.777.067-3.804-.953-3.737-3.733.139-5.765.042-11.536.042-17.305 5.769 0 11.541.097 17.307-.042 2.776-.067 3.806.952 3.739 3.734-.14 5.766-.044 11.538-.046 17.307z"
    />
    <path
      fill="#272914"
      d="M635.182 313.717c-5.769-.002-11.54-.102-17.306.037-2.779.067-3.802-.956-3.736-3.735.138-5.766.039-11.537.037-17.306 5.769 0 11.541.097 17.307-.043 2.781-.067 3.801.963 3.734 3.739-.136 5.767-.037 11.539-.036 17.308z"
    />
    <path
      fill="#40461E"
      d="m593.195 250.7-.039-20.933 21.027-.057-.057.055.089 20.916c-7.006.005-14.013.012-21.02.019z"
    />
    <path
      fill="#959B76"
      d="m194.128 271.789 20.814.023.261-.106.025 21.031-.301-.127-20.729.114-.07-20.935z"
    />
    <path
      fill="#40461E"
      d="m236.177 292.718-.062 21.078-20.946-.092.031.032-.273-21.127.3.126 20.95-.017z"
    />
    <path
      fill="#6B762F"
      d="m488.187 145.708.038-21.052c6.981.03 13.962.059 20.942.09l.021 20.963-21.001-.001z"
    />
    <path
      fill="#40461E"
      d="m551.152 187.707 41.969-.002.081 21.013-.008.01c-5.666-.003-11.335.116-16.996-.059-2.989-.092-4.187.857-4.079 3.975.196 5.659.059 11.33.061 16.996l.015.115-20.937.035-.19-.187.008-20.729.076-21.167z"
    />
    <path
      fill="#747956"
      d="m614.182 229.709-21.027.057.069-.117-.031-20.922.008-.01 20.99-.015c-.002 7.003-.005 14.005-.009 21.007z"
    />
    <path
      fill="#40461E"
      d="M320.125 376.684c5.773.015 11.549.127 17.32.003 2.747-.059 3.841.887 3.771 3.704-.143 5.77-.042 11.546-.042 17.32l-41.981-.006-.01-20.99.003-.003 20.939-.028zM278.239 376.657l-.086-20.884 20.936-.04.21-.094-.113 21.072-.003.003-20.944-.057zM551.259 229.79c-.029 5.658-.197 11.319-.032 16.971.09 3.082-1.045 4.091-4.057 3.997-5.653-.175-11.315-.05-16.973-.049l-.01-.01-.006-20.983 20.889-.112.189.186z"
    />
    <path
      fill="#272914"
      d="M278.184 313.718c-.003-5.305-.115-10.612.035-15.912.082-2.875-.692-4.227-3.878-4.142-12.733.342-25.415-1.642-38.164-.946l.004-21.004-.002.002 21.053-.042 20.935.03c.007 5.496.187 11-.042 16.486-.143 3.442.942 4.649 4.497 4.594 12.489-.194 24.982-.091 37.474-.1l.077 21.053-20.885.008-21.104-.027zM299.089 355.732l-20.936.04-20.977-.118c.003-5.826.085-11.654-.028-17.477-.05-2.595.957-3.545 3.523-3.496 5.824.11 11.651.033 17.477.032l20.89-.02.051 21.039z"
    />
    <path
      fill="#5E6337"
      d="m215.169 313.705 20.946.092-.014 20.815c-5.662.027-11.328-.076-16.982.136-3.098.116-4.08-1.055-3.989-4.059.172-5.657.043-11.322.039-16.984z"
    />
    <path
      fill="#1B1A0C"
      d="m299.037 334.693-20.89.02.037-20.995 21.105.027-.252 20.948z"
    />
    <path
      fill="#40461E"
      d="M404.19 208.706c5.621.007 11.249-.144 16.862.079 3.33.132 4.227-1.162 4.195-4.327-.128-12.564-.034-25.13-.021-37.695l41.969-.034.034 20.985-.02 20.967-.01 20.963-.028.121-20.982-.018-21.032.015-20.975-.054-.037-20.957.045-.045z"
    />
    <path
      fill="#747956"
      d="M488.225 166.762c12.573-.027 25.148.071 37.717-.157 3.687-.067 4.445 1.408 4.324 4.668-.201 5.452-.047 10.917-.043 16.377l-.009 21.139.021-.048-21.113.062-20.899-.13-.099-20.959.101-20.952z"
    />
    <path
      fill="#555A40"
      d="m488.225 166.762-.099 20.952-20.896-.001-.035-20.985 21.03.034zM530.214 208.789l.009-21.139 20.929.058-.076 21.167c-6.954-.03-13.908-.058-20.862-.086zM215.234 187.705l20.932.044.046 20.986-.075-.041-20.935.044-.08-.082.112-20.951z"
    />
    <path
      fill="#555A40"
      d="M194.193 229.675c0-5.66.128-11.324-.051-16.978-.095-3.024.931-4.141 4.004-4.047 5.654.174 11.318.023 16.977.006l.079.081-.01 20.945-20.999-.007z"
    />
    <path
      fill="#31361B"
      d="m194.193 229.675 20.999.008-.032.079.035 20.974-.037-.004-21.01-.199.045-20.858z"
    />
    <path
      fill="#272914"
      d="m214.943 271.812.216-21.08.036.005 20.988.001-.004 20.98.002-.002-20.978-.009-.26.105zM404.183 229.707l20.975.054.025 20.975c0 5.637-.11 11.277.045 16.91.08 2.9-.733 4.268-3.901 4.122-4.467-.206-8.954-.163-13.426-.012-2.782.094-3.875-.926-3.769-3.74.156-4.139-.238-8.312.116-12.427.356-4.14-1.357-5.124-5.135-4.932-5.292.269-10.608.071-15.913.073l-.014-21.02-.008.007 21.005-.01z"
    />
    <path
      fill="#505721"
      d="m341.192 250.704 20.96.013.034 20.971-.017.107-20.989-.07-.025-20.983.037-.038z"
    />
    <path
      fill="#31361B"
      d="m362.185 271.688-.034-20.971 21.008-.016-.06 21.093-20.914-.106z"
    />
    <path
      fill="#272914"
      d="m362.21 208.802 20.972-.105-.026.082.024 20.938.008-.007c-5.661-.001-11.325-.124-16.98.048-2.99.091-4.181-.864-4.072-3.975.196-5.655.066-11.32.074-16.981z"
    />
    <path
      fill="#5E6337"
      d="m278.203 166.751.008 20.942-21.03.013.054-20.937 20.968-.018z"
    />
    <path
      fill="#5E6823"
      d="m236.212 208.735 20.972-.011-.022 20.955-21.002.036-.023-21.02.075.04z"
    />
    <path
      fill="#505721"
      d="m257.162 229.679.022-20.954 21.025.036.007 20.993.026.058-21.08-.133z"
    />
    <path
      fill="#31361B"
      d="m383.179 229.717-.024-20.938 20.991-.029.037 20.957-21.004.01z"
    />
    <path
      fill="#1B1A0C"
      d="m299.073 229.824.123 20.896-.07-.034-20.901.009-.061.025.078-20.909-.026-.058 20.857.071z"
    />
    <path
      fill="#31361B"
      d="m299.196 250.719 20.959-.005.063-.004-.089 21.036-20.934-.049-.068-21.014.069.036z"
    />
    <path
      fill="#555A40"
      d="m320.128 271.747.09-21.037 20.938.03.025 20.983-.001-.016-20.984.029-.068.011z"
    />
    <path
      fill="#31361B"
      d="m530.18 229.716.006 20.983-21.006.024c-5.768-.008-11.539.081-17.304-.064-2.766-.069-3.82.928-3.746 3.721.154 5.765.074 11.535.091 17.304l-.038 20.94-20.952.135-.084-21.067.037-20.984-.013-20.941.028-.121 42.006.019 21.06-.044-.085.095z"
    />
    <path
      fill="#555A40"
      d="m362.185 271.688 20.914.107-.041 20.893-20.884.026-.006-20.919.017-.107z"
    />
    <path
      fill="#40461E"
      d="m362.174 292.714 20.884-.026.044 20.938-20.91.092-.16.077.146-21.085-.004.004z"
    />
    <path
      fill="#31361B"
      d="m425.182 250.736-.025-20.975 21.031-.014-.038 20.924-20.968.065z"
    />
    <path
      fill="#272914"
      d="m446.151 250.67.038-20.924 20.982.019.013 20.942-21.033-.037z"
    />
    <path
      fill="#747956"
      d="m299.289 313.745 20.885-.008c.007 5.774.125 11.552-.028 17.322-.074 2.797.914 3.777 3.706 3.701 5.77-.158 11.547-.049 17.322-.05l-.004-.004-.026 20.918-20.927.153-20.918-.139-.21.094"
    />
    <path
      fill="#747956"
      d="m362.192 313.718-.115 21.011-20.906-.022.004.004.097-20.923 20.76.009c-.001-.001.16-.079.16-.079z"
    />
    <path
      fill="#5E6337"
      d="m299.299 355.638 20.918.139-.091 20.907-20.94.026.113-21.072z"
    />
    <path
      fill="#1B1A0C"
      d="M488.221 271.684c-.016-5.768.063-11.539-.091-17.304-.075-2.792.98-3.79 3.746-3.721 5.765.144 11.536.056 17.304.064 0 5.832-.077 11.666.035 17.496.049 2.568-.899 3.579-3.498 3.525-5.83-.123-11.664-.052-17.496-.06zM509.196 313.7l.006-20.968c5.77-.008 11.542.081 17.309-.066 2.795-.071 3.788.991 3.721 3.753-.141 5.767-.052 11.539-.058 17.309l-20.978-.028z"
    />
    <path
      fill="#555A40"
      d="m593.194 208.728.031 20.922-21.044-.009c-.002-5.667.134-11.337-.062-16.996-.108-3.118 1.09-4.067 4.079-3.975 5.661.174 11.33.055 16.996.058z"
    />
    <path
      fill="#31361B"
      d="m215.203 271.705 20.978.009-.004 21.004-20.95.017-.024-21.03z"
    />
    <path
      fill="#959B76"
      d="m530.214 208.789 20.862.085-.008 20.73-20.889.112.084-.096-.028-20.879-.021.048z"
    />
    <path
      fill="#31361B"
      d="m278.242 229.811-.077 20.909c-5.831.001-11.663.08-17.491-.034-2.575-.05-3.571.903-3.514 3.499.128 5.828.06 11.66.072 17.491l-21.053.042.004-20.98.021-21.004-.044-.018 21.002-.036 21.08.131z"
    />
    <path
      fill="#1B1A0C"
      d="m299.194 271.698 20.934.049.067-.01-.021 20.958-.077-.011c-12.492.01-24.985-.094-37.474.101-3.555.055-4.64-1.151-4.497-4.594.229-5.486.049-10.99.042-16.486l.002-.003 21.024-.004z"
    />
    <path
      fill="#31361B"
      d="m341.272 313.787-.097 20.923c-5.774.001-11.552-.108-17.322.05-2.792.076-3.78-.904-3.706-3.701.152-5.77.035-11.547.028-17.322l-.077-21.052.076.011 20.925.036.122-.037c.016 7.031.034 14.062.051 21.092z"
    />
    <path
      fill="#505721"
      d="M257.232 271.675c-.012-5.831.055-11.663-.072-17.491-.057-2.595.939-3.549 3.514-3.499 5.828.114 11.661.035 17.491.034l.06-.025-.055 21.008-.002.003-20.936-.03zM509.205 229.664l-42.006-.019.01-20.964 21.015-.008c6.966.043 13.932.087 20.899.129l.082 20.862z"
    />
    <path
      fill="#5E6337"
      d="m488.224 208.673-21.015.008.02-20.967 20.897.001.098 20.958zM509.205 229.664l-.082-20.862 21.113-.061.029 20.879-21.06.044z"
    />
    <path
      fill="#747956"
      d="m236.137 208.695.023 21.021.044.018-21.044.029.032-.079.01-20.945 20.935-.044z"
    />
    <path
      fill="#505721"
      d="m215.16 229.762 21.044-.029-.021 21.004-20.988-.001-.035-20.974z"
    />
    <path
      fill="#5E6337"
      d="m362.168 271.795.006 20.919.004-.003-20.958-.015-.121.037.079-21.023.001.016c6.997.022 13.993.045 20.989.069z"
    />
    <path
      fill="#272914"
      d="m278.17 271.703.055-21.008 20.902-.01.068 21.014-21.025.004z"
    />
    <path
      fill="#40461E"
      d="m341.179 271.709-.079 21.023-20.926-.036.021-20.958 20.984-.029z"
    />
    <path
      fill="#555A40"
      d="m341.22 292.695 20.958.015-.146 21.085-20.761-.008-.051-21.092z"
    />
    <path fill="#2E4029" d="M298.552 564.253h22.892v22.892h-22.892z"/>
    <path fill="#36321E" d="M321.444 564.253h22.892v22.892h-22.892z"/>
    <path
      fill="#0F7540"
      d="M344.336 564.253h22.892v22.892h-22.892zM367.228 564.253h22.892v22.892h-22.892z"
    />
    <path fill="#80A82B" d="M229.876 587.145h22.892v22.892h-22.892z"/>
    <path fill="#35471D" d="M252.768 587.145h22.892v22.892h-22.892z"/>
    <path fill="#80A82B" d="M275.66 587.145h22.892v22.892H275.66z"/>
    <path fill="#81B829" d="M298.552 587.145h22.892v22.892h-22.892z"/>
    <path fill="#80A82B" d="M321.444 587.145h22.892v22.892h-22.892z"/>
    <path fill="#81B829" d="M344.336 587.145h22.892v22.892h-22.892z"/>
    <path fill="#0F7540" d="M367.228 587.145h22.892v22.892h-22.892z"/>
    <path fill="#80A82B" d="M390.12 587.145h22.892v22.892H390.12z"/>
    <path fill="#81B829" d="M413.012 587.145h22.892v22.892h-22.892z"/>
    <path fill="#A7C56C" d="M435.904 587.145h22.892v22.892h-22.892z"/>
    <path fill="#81B829" d="M458.796 587.145h22.892v22.892h-22.892z"/>
    <path fill="#2E4029" d="M298.552 564.253h22.892v22.892h-22.892z"/>
    <path fill="#36321E" d="M321.444 564.253h22.892v22.892h-22.892z"/>
    <path
      fill="#0F7540"
      d="M344.336 564.253h22.892v22.892h-22.892zM367.228 564.253h22.892v22.892h-22.892z"
    />
    <path fill="#80A82B" d="M229.876 587.145h22.892v22.892h-22.892z"/>
    <path fill="#35471D" d="M252.768 587.145h22.892v22.892h-22.892z"/>
    <path fill="#80A82B" d="M275.66 587.145h22.892v22.892H275.66z"/>
    <path fill="#81B829" d="M298.552 587.145h22.892v22.892h-22.892z"/>
    <path fill="#80A82B" d="M321.444 587.145h22.892v22.892h-22.892z"/>
    <path fill="#81B829" d="M344.336 587.145h22.892v22.892h-22.892z"/>
    <path fill="#0F7540" d="M367.228 587.145h22.892v22.892h-22.892z"/>
    <path fill="#80A82B" d="M390.12 587.145h22.892v22.892H390.12z"/>
    <path fill="#81B829" d="M413.012 587.145h22.892v22.892h-22.892z"/>
    <path fill="#A7C56C" d="M435.904 587.145h22.892v22.892h-22.892z"/>
    <path fill="#81B829" d="M458.796 587.145h22.892v22.892h-22.892z"/>
  </svg>
);

export default Frondosas;